import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
} from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import { Link } from "react-router-dom";

interface FooterMenuProps {
  link?: string;
  listItemName: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

const FooterMenuItem: React.FC<FooterMenuProps> = ({
  link,
  listItemName,
  onClick,
}) => {
  return (
    <ListItem disablePadding>
      <ListItemButton
        component={Link}
        to={link || "#"} // ✅ safe fallback
        onClick={onClick} // ✅ IMPORTANT (this was missing)
        sx={{
          px: '10px',
          py: 0.5,
          "&:hover": {
            color: "#E4BFFF",
            "& .MuiListItemIcon-root": {
              color: "#E4BFFF",
            },
          },
        }}
      >
        <ListItemIcon sx={{ minWidth: 20, color: "#acacac" }}>
          <CircleIcon sx={{ fontSize: 8 }} />
        </ListItemIcon>

        <ListItemText
          primary={listItemName}
          primaryTypographyProps={{
            sx: {
              fontSize: 14,
              fontWeight: 300,
            },
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};

export default FooterMenuItem;
